import React from 'react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      text: "진짜 커피 한 잔 마시면서 옛날 이야기하듯 편하게 말했을 뿐인데, 그 동안 성과라고 생각해보지 못했던 내용들까지 기억나게 해주고 그걸 모두 정량화 한 가치로 바꿔주니 정말 그럴 듯한 이력서가 만들어지더라구요.",
      author: "L사",
      role: "14년차 개발자 김OO님"
    },
    {
      text: "그냥 푸념하듯 얘기한 야근 스토리가 '위기관리 능력'과 '프로젝트 리더십'으로 정리되는 걸 보고 놀랐어요. 저 혼자는 찾아낼 수 없는 제 찐 가치였어요",
      author: "S전자",
      role: "5년차 기획자 이OO님"
    },
    {
      text: "손짓발짓으로 계약 따온 얘기, 술자리 무용담인 줄만 알았는데... 이게 '글로벌 비즈니스 개발 성과'였다니! 특히 제 7년 영업 성과를 숫자로 표현하니 저 정말 열심히 살았더라구요!",
      author: "D물산",
      role: "7년차 영업팀장 박OO님"
    },
    {
      text: "30년간 조선소에서 일했는데 이력서를 어떻게 써야 할지 막막했어요. 그냥 '배 만들고 팔았다'고만 생각했는데... 라떼 컨설턴트랑 대화하니까 'LNG선 수주 300억 달러' 이런 게 다 나오더라고요.",
      author: "S중공업",
      role: "30년차 조선 기술영업 부장 한OO님"
    },
    {
      text: "'그 스타트업 왜 투자했어?' 물으면 그냥 '감이 좋았다'고만 했었죠. 라떼매니저가 '그때 어떤 지표를 봤나요?' '경쟁사 대비 뭐가 달랐나요?' 계속 물어봐서 대답하다 보니... '시장 성장률 연 47% 분석', '경쟁사 대비 CAC 73% 절감' 이런 구체적인 숫자들이 정리 되었어요!",
      author: "B투자사",
      role: "10년차 VC 심사역 윤OO님"
    },
    {
      text: "밤새 야근하며 구글링했던 기억, 실패했던 프로젝트 얘기까지... 모든 경험이 의미 있는 성장 스토리로 바뀌네요. 게다가 이력서가 실시간으로 생성되니 신나서 얘기하게 되더라구요",
      author: "C사",
      role: "8년차 MD 정OO님"
    },
    {
      text: "20년이나 됐으니 기억이 가물가물했죠. '창고 효율화 했다' 정도만 기억났는데... 라떼매니저가 'WMS 도입하셨나요?', 'Cross-docking 적용하셨나요?', '피킹 방식은 뭘 쓰셨나요?' 이런 전문 용어로 물어봐서 대답하다 보니... '아! 맞다!' 하면서 술술 생각나더라구요.",
      author: "H사",
      role: "20년차 물류센터장 최OO님"
    },
    {
      text: "채용공고 보고 지원할 때마다 자소서 처음부터 다시 쓰느라 힘들었는데, 라떼매니저가 JD 분석해서 '이 회사는 데이터 기반 의사결정을 중요시하네요', '협업 경험을 강조하세요' 이렇게 맞춤 질문을 해주니까 답변하기만 하면 자소서가 완성되더라구요. 서류 합격률이 3배는 올라간 것 같아요!",
      author: "T커머스",
      role: "3년차 마케터 송OO님"
    },
    {
      text: "처음엔 그냥 이력서 정리만 하려고 했는데, 30분 대화 끝나니까 영문 이력서는 물론이고 제 웹페이지까지 바로 만들 수 있더라구요. 득템한 기분이었어요~",
      author: "N사",
      role: "6년차 데이터분석가 강OO님"
    }
  ];

  return (
    <section className="testimonials-section">
      <div className="container">
        <div className="section-title">
          <h2>라떼 컨설턴트를 만난 사람들의 찐 후기</h2>
        </div>
        
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card-modern">
              <p className="testimonial-text">"{testimonial.text}"</p>
              <div className="testimonial-author-info">
                <p className="testimonial-author">{testimonial.author} · {testimonial.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;